var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        multiple: "",
        "no-data-text": "No tienes distribuciones con copia",
        data: _vm.copies
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: tr } },
                [
                  _c(
                    "vs-td",
                    { attrs: { data: data[indextr].copySubjectType.label } },
                    [_vm._v(" " + _vm._s(tr.copySubjectType.label) + " ")]
                  ),
                  _c(
                    "vs-td",
                    { attrs: { data: data[indextr].copySubject.label } },
                    [
                      _vm._v(" " + _vm._s(tr.copySubject.label) + " "),
                      _vm.isExternSubjects.includes(tr.copySubjectType.value)
                        ? _c("div", [
                            _c("span", [
                              _vm._v(" " + _vm._s(tr.copySubjectEmail) + " ")
                            ])
                          ])
                        : _vm._e()
                    ]
                  ),
                  data[indextr].copySubjectTypeDigitalDoc.label
                    ? _c(
                        "vs-td",
                        {
                          attrs: {
                            data: data[indextr].copySubjectTypeDigitalDoc.label
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(tr.copySubjectTypeDigitalDoc.label) +
                              " "
                          ),
                          _c("small", { staticClass: "d-block" }, [
                            _vm._v("institución")
                          ])
                        ]
                      )
                    : _vm._e(),
                  data[indextr].providence
                    ? _c(
                        "vs-td",
                        { attrs: { data: data[indextr].providence } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.providencesMap[tr.providence]) +
                              " "
                          ),
                          data[indextr].providenceExpiration
                            ? _c("span", [
                                _vm._v(
                                  " - " +
                                    _vm._s(
                                      _vm._f("dateFormat")(
                                        tr.providenceExpiration
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e(),
                          _c("small", { staticClass: "d-block" }, [
                            _vm._v("providencia")
                          ])
                        ]
                      )
                    : _vm._e(),
                  tr.copySubjectType.value === "sanitarias"
                    ? _c(
                        "vs-td",
                        { attrs: { data: data[indextr].subjectEmail } },
                        [
                          _c("span", [
                            _vm._v(" " + _vm._s(tr.subjectEmail) + " ")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            })
          }
        }
      ]),
      model: {
        value: _vm.copiesSelected,
        callback: function($$v) {
          _vm.copiesSelected = $$v
        },
        expression: "copiesSelected"
      }
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Distribución")]),
          _c("vs-th", [_vm._v("Lista Distribución")]),
          _c("vs-th", [_vm._v("Extra")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }